import { PredictiveETAParams, PredictiveETAResponse } from "../types/PredictiveETAAddress";

export const FETCH_PREDICTIVE_ETA = "FETCH_PREDICTIVE_ETA" as const;
export const FETCH_PREDICTIVE_ETA_SUCCESS = "FETCH_PREDICTIVE_ETA_SUCCESS" as const;
export const FETCH_PREDICTIVE_ETA_FAILED = "FETCH_PREDICTIVE_ETA_FAILED" as const;

export const fetchPredictiveETA = (payload: PredictiveETAParams) => ({ type: FETCH_PREDICTIVE_ETA, payload } as const);
export const fetchPredictiveETASuccess = (data: PredictiveETAResponse) => ({ type: FETCH_PREDICTIVE_ETA_SUCCESS, payload: data } as const);
export const fetchPredictiveETAFailed = () => ({ type: FETCH_PREDICTIVE_ETA_FAILED } as const);

export type PredictiveETAActions =
  | ReturnType<typeof fetchPredictiveETA>
  | ReturnType<typeof fetchPredictiveETASuccess>
  | ReturnType<typeof fetchPredictiveETAFailed>;